import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { useSelector } from 'react-redux';
import { useTranslate } from 'lib/translate';

var Expire = /*#__PURE__*/function (_Component) {
  _inherits(Expire, _Component);

  var _super = _createSuper(Expire);

  function Expire(props) {
    var _this;

    _classCallCheck(this, Expire);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this.setTimer();
    });

    _defineProperty(_assertThisInitialized(_this), "setTimer", function () {
      // clear any existing timer
      if (_this._timer != null) {
        clearTimeout(_this._timer);
      } // set visible and create timeout on this._timer


      _this.setState({
        visible: true
      }, function () {
        _this._timer = setTimeout(function () {
          _this.setState({
            visible: false
          });

          _this._timer = null;

          if (_this.props.onExpire) {
            _this.props.onExpire();
          }
        }, _this.props.delay);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      clearTimeout(_this._timer);
    });

    _defineProperty(_assertThisInitialized(_this), "render", function () {
      return _this.state.visible ? /*#__PURE__*/React.createElement("div", {
        className: "error type-".concat(_this.props.type, " is-visible")
      }, _this.props.children) : null;
    });

    _this.state = {
      visible: true
    };
    _this._timer = null;
    return _this;
  }

  return _createClass(Expire);
}(Component);

_defineProperty(Expire, "defaultProps", {
  delay: 9000
});

var Error = function Error() {
  var translate = useTranslate();
  var errors = useSelector(function (state) {
    return state.errors;
  });

  var renderError = function renderError(error, i) {
    if (error.viewed == true) {
      return null;
    }

    return /*#__PURE__*/React.createElement(Expire, {
      key: 'error-' + i,
      onExpire: function onExpire() {
        return error.viewed = true;
      },
      type: error.type ? error.type : 'warning'
    }, /*#__PURE__*/React.createElement("div", {
      className: "content"
    }, error.msg != null ? error.msg : error.translateMsg != null ? translate(error.translateMsg) : null));
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "error-messages-container"
  }, errors.map(renderError));
};

export default Error;